module.exports = __webpack_public_path__ + "static/img/企业文化-1.83769ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/企业文化-1.png
// module id = QaRI
// module chunks = 38